export function getPublicUserLabels(user: {
  username: string
  displayName: string
  email?: string
}): {
  primary: string
  secondary: string | null
  avatar: string
} {
  const username = user.username.trim()
  const handle = username ? `@${username}` : ''
  const displayName = user.displayName.trim()
  const email = user.email?.trim() ?? ''
  const normalizedDisplayName = displayName.startsWith('@')
    ? displayName.slice(1)
    : displayName
  const distinct
    = !!displayName
      && normalizedDisplayName.toLocaleLowerCase() !== username.toLocaleLowerCase()
  return {
    primary: distinct ? displayName : handle || email,
    secondary: distinct && handle ? handle : null,
    avatar: username || displayName || email,
  }
}
